import React from 'react';
import { Button } from '@/Components/ui/button';
import { Heading } from '@/Components/ui/typography';
import { Stack } from '@/Components/ui/layout';

function SocialMedia() {
  return (
    <div className="rounded-lg flex mt-8 w-full max-w-[536px] flex-col">
      <Heading level="h2" size="sm" className="font-medium text-slate-900 m-0">
        Follow me Social Media
      </Heading>
      <div className="flex mt-4.5 items-start gap-3">
        <Button variant="ghost" size="icon" className="w-12 h-12 rounded bg-blue-50" aria-label="Social Media 1">
          <span className="w-5 h-5">📱</span>
        </Button>
        <Button variant="ghost" size="icon" className="w-12 h-12 rounded bg-blue-600" aria-label="Social Media 2">
          <span className="w-5 h-5">📱</span>
        </Button>
        <Button variant="ghost" size="icon" className="w-12 h-12 rounded bg-blue-50" aria-label="Social Media 3">
          <span className="w-5 h-5">📱</span>
        </Button>
        <Button variant="ghost" size="icon" className="w-12 h-12 rounded bg-blue-50" aria-label="Social Media 4">
          <span className="w-5 h-5">📱</span>
        </Button>
        <Button variant="ghost" size="icon" className="w-12 h-12 rounded bg-blue-50" aria-label="Social Media 5">
          <span className="w-5 h-5">📱</span>
        </Button>
        <Button variant="ghost" size="icon" className="w-12 h-12 rounded bg-blue-50" aria-label="Social Media 6">
          <span className="w-5 h-5">📱</span>
        </Button>
      </div>
    </div>
  );
}

export default SocialMedia;